const itineraries = {
  DubaiOne: [
    {
      day: "Day 1",
      title: "After Arrival in Dubai",
      content:
        "Just after completing the entire immigration formalities, the tour representative will take you to the hotel (Hotel category as per your booking). You can rest or visit the nearest market (e.g., Deira City Center) for shopping."
    },
    {
      day: "Day 2",
      title: "Dubai City Tour & Desert Safari with BBQ Dinner",
      content:
        "After breakfast, enjoy a half-day city tour with mind-blowing sights. After lunch, embark on a thrilling Desert Safari ending with a fascinating BBQ dinner, belly dancing, and camel riding. Overnight stay at the hotel."
    },
    {
      day: "Day 3",
      title: "Burj Khalifa, Dubai Mall & Dhow Cruise Dinner",
      content:
        "After breakfast, visit Burj Khalifa and shop at Dubai Mall. The day is free for leisure. In the evening, enjoy a Dhow Cruise at Dubai Creek with entertainment shows and a buffet dinner. Pickup and drop-off included."
    },
    {
      day: "Day 4",
      title: "Abu Dhabi City Tour",
      content:
        "Enjoy breakfast at the hotel, followed by a full-day tour of Abu Dhabi, the capital of UAE. Sightseeing with a professional guide and approx. 8-hour exploration. Return to hotel in the evening."
    },
    {
      day: "Day 5",
      title: "Departure from Dubai",
      content:
        "Enjoy final shopping hours (timed with your flight). Driver will arrive at night for airport drop-off, marking the end of your Dubai journey."
    }
  ],
  Dubaitwo: [
    {
      day: "Day 1",
      title: "Welcome to Dubai. Enjoy Dhow Cruise with Dinner",
      content:
        "Once you arrive, a representative will escort you at the airport and drop you at your hotel. Check into the hotel and take some rest. Later in the evening, sail through the city’s waterways on a traditional Dhow Cruise and enjoy a tasty buffet dinner in a royal setting. Transfer back to the hotel and sleep for the night."
    },
    {
      day: "Day 2",
      title: "Half-day Dubai City Tour and Visit to Burj Khalifa",
      content:
        "Post a hearty breakfast, set out for a joyful half-day Dubai city tour. Visit the Dubai Museum, Jumeirah Mosque, Burj Al Arab, Atlantis Hotel, Palm Island, and Jumeirah Beach. Shop at renowned malls. In the evening, visit Burj Khalifa’s observation deck. Return to hotel for overnight stay."
    },
    {
      day: "Day 3",
      title: "Dolphinarium Visit and Desert Safari Tour",
      content:
        "After breakfast, visit the Dolphinarium for poolside and underwater interactions with dolphins. Later, enjoy an adventurous Desert Safari with dune bashing, cultural performances, and a barbecue dinner. Return to the hotel and retire for the night."
    },
    {
      day: "Day 4",
      title: "Abu Dhabi City Tour and Ferrari World",
      content:
        "After an early breakfast, head for a full-day Abu Dhabi city tour exploring both ancient and modern sights. Then visit Ferrari World for thrilling F1 rides and attractions. After dinner, return to the hotel in Dubai for overnight stay."
    },
    {
      day: "Day 5",
      title: "Aquaventure Waterpark and Lost Chambers",
      content:
        "Post breakfast, visit Aquaventure Waterpark and the Lost Chambers at Atlantis The Palm. Enjoy thrilling water rides and explore marine life. Return to the hotel and rest overnight."
    },
    {
      day: "Day 6",
      title: "Dubai Aquarium & Underwater Zoo",
      content:
        "After breakfast, visit the Dubai Aquarium and Underwater Zoo in Dubai Mall. Let kids enjoy watching sharks, rays, and snakes up close. Spend the rest of the day shopping and exploring Dubai. Return to the hotel and sleep peacefully."
    },
    {
      day: "Day 7",
      title: "Departure from Dubai",
      content:
        "Enjoy breakfast and spend the morning shopping for souvenirs or exploring. You’ll be transferred to the airport in the evening for your flight back home with beautiful memories of your Dubai trip."
    }
  ],
  DubaiThree: [
    {
      day: "Day 1",
      title: "Air Port Pick Up & UAE 4G SIM Card",
      content:
        "Upon arrival, our driver will greet you at the airport, assist with your baggage, and transfer you to your hotel. Redeem your booking voucher at the Bookmywifi counter at Terminal 1 or 3 to collect your 4G SIM card. Choose from various packs and stay connected throughout your trip."
    },
    {
      day: "Day 2",
      title: "Full Day Explore Dubai City Tour",
      content:
        "Begin the day with a hotel pickup for a full-day city tour. Visit iconic souks like Gold and Spice Souk, explore the historic Bastakiya Quarter, and admire architectural marvels such as Madinat Jumeirah, Palm Jumeirah, and Burj Al Arab. End the tour at Burj Khalifa and enjoy the fountain show at Dubai Mall."
    },
    {
      day: "Day 3",
      title: "Dubai Burj Khalifa Tour & Glow Garden",
      content:
        "Visit the Burj Khalifa, ascend to the 124th floor via one of the world’s fastest elevators, and enjoy panoramic views of Dubai. Later, explore the Glow Garden – a unique eco-friendly park with glowing installations, crafted by artisans using biodegradable materials."
    },
    {
      day: "Day 4",
      title: "Wonder Bus & Dhow Cruise Dinner - Creek",
      content:
        "Hop on the Wonder Bus, an amphibious vehicle that tours Dubai by land and water. Later in the evening, enjoy a traditional Dhow Cruise dinner on the Creek with entertainment, delicious buffet, and scenic views of the city from the water."
    },
    {
      day: "Day 5",
      title: "Yellow Boats Dubai & Desert Safari",
      content:
        "Start your day with a Yellow Boat tour, cruising past landmarks like Palm Jumeirah, Burj Al Arab, and Dubai Marina. In the afternoon, embark on a thrilling Desert Safari with dune bashing, camel rides, cultural shows, and a BBQ dinner under the stars."
    },
    {
      day: "Day 6",
      title: "Bollywood Parks Dubai",
      content:
        "Get ready for a fun-filled day at Bollywood Parks Dubai. Explore five zones themed on hit Bollywood movies, enjoy live entertainment and rides. You can also upgrade to include Legoland Water Park for added excitement."
    },
    {
      day: "Day 7",
      title: "Abu Dhabi City Tour With Ferrari World",
      content:
        "Travel to Abu Dhabi for a city tour covering Sheikh Zayed Mosque, Emirates Palace, Heritage Village, and more. Then spend the rest of the day at Ferrari World, enjoying thrilling rides and F1 attractions before returning to Dubai."
    },
    {
      day: "Day 8",
      title: "Shopping Tour",
      content:
        "Enjoy a relaxed day shopping across Dubai’s best markets, including Gold Souks and Spice Souks. Our driver will accompany you for convenient transport and drop you back to your hotel after a fulfilling shopping spree."
    },
    {
      day: "Day 9",
      title: "Air Port Drop Off",
      content:
        "It’s time to say goodbye to Dubai. Our driver will pick you up from your hotel and drop you at the airport for your departure flight. Take home amazing memories from your Dubai trip."
    }
  ],
  JapanOne: [
  {
    day: "Day 1",
    title: "Arrival Tokyo",
    content:
      "Arrive in Japan – The Land of the Rising Sun. Upon arrival at Narita/Haneda Airport, receive a warm welcome and transfer to the hotel by Limousine Bus. Check in to your hotel. The rest of the day is free for leisure. Dinner at your own. Overnight stay at the hotel in Tokyo."
  },
  {
    day: "Day 2",
    title: "Tokyo – Mt. Fuji – Lake Ashi – Tokyo",
    content:
      "After breakfast, proceed to Hakone by super luxury coach. Enjoy the scenic drive from bustling Tokyo to the serene countryside. Visit Mt. Fuji (weather permitting), starting with the Fuji Visitor Center and the 5th Station. Take a cruise on Lake Ashi and enjoy a traditional Japanese-style lunch (Veg/Non-Veg). After lunch, ride the Mt. Komagatake Ropeway for panoramic views. Return to Tokyo (Shinjuku/Ginza). Dinner at your own. Overnight at the hotel in Tokyo."
  },
  {
    day: "Day 3",
    title: "Tokyo Half Day City Tour",
    content:
      "After breakfast, head to the pickup point for a half-day Tokyo city tour. Visit Tokyo Tower, the Imperial Palace Plaza, and the Asakusa Kannon Temple. Enjoy shopping at Nakamise Street and drive through Ueno and Akihabara. Lunch at your own. Evening is free for leisure. Dinner at your own. Overnight at the hotel in Tokyo."
  },
  {
    day: "Day 4",
    title: "Tokyo Departure",
    content:
      "After breakfast, check out from the hotel by 10:00 hrs. Transfer to Narita Airport for your international flight. Depart with sweet memories of Japan."
  }
  ],
  JapanTwo : [
  {
    day: "Day 1",
    title: "Arrival Tokyo",
    content:
      "Arrive in Japan – The Land of Rising Sun. Upon arrival at Narita/Haneda Airport, receive a warm welcome. Transfer to the Disney Resort by seat-in-coach. 15:00 Check-in to the hotel. Day free at leisure. Dinner at your own. Overnight at the Disney Resort Hotel in Tokyo."
  },
  {
    day: "Day 2",
    title: "Disneyland Tour",
    content:
      "After breakfast, proceed to Disneyland and enjoy the seven theme parks: Adventureland, Westernland, Fantasyland, Tomorrowland, World Bazaar, Critter Country, and Mickey's Toontown. Return to the Disney Resort. Overnight stay in Tokyo."
  },
  {
    day: "Day 3",
    title: "Disney Sea",
    content:
      "After breakfast, check out from the hotel at 09:00 and concierge your luggage. Head to DisneySea and explore the six nautically-themed ports: American Waterfront, Lost River Delta, Port Discovery, Mermaid Lagoon, Arabian Coast, and Mysterious Island. Return to the resort, collect your luggage, and transfer on your own to the next hotel. Check-in and overnight stay in Central Tokyo."
  },
  {
    day: "Day 4",
    title: "Full Day Tokyo City Tour",
    content:
      "After breakfast, gather at the designated locations between 07:30 – 08:30 to board the bus to Hamamatsucho Bus Terminal. Visit Tokyo Tower (150m observatory), experience a traditional tea ceremony, and enjoy a Japanese-style lunch. Continue to the Imperial Palace Plaza, Niju-bashi Bridge, Sumida River Cruise, Asakusa Kannon Temple & shopping at Nakamise, drive-by Ginza. Tour ends at Tokyo Station Marunouchi South Exit or Hamamatsucho Terminal. Return to hotel on your own. Overnight stay in Central Tokyo."
  },
  {
    day: "Day 5",
    title: "Tokyo – Osaka",
    content:
      "After breakfast, check out by 08:00 and proceed to Tokyo Station on your own. Board the Shinkansen NOZOMI at 09:00 to Osaka (2 hrs 48 min). Head to the hotel and concierge your luggage. By 13:00, proceed to Hotel Granvia Osaka and board the train to Osakako Station. Visit Kaikyukan Aquarium and Tempozan Marketplace. Then, enjoy a cruise on Osaka Bay aboard the Santa Maria. The tour ends at Osaka Station. Return to the hotel on your own. Check in and overnight stay in Osaka."
  },
  {
    day: "Day 6",
    title: "Universal Studios Osaka",
    content:
      "After breakfast, proceed on your own for a full-day visit to Universal Studios Japan with a 1-day pass. Explore various themed areas including Hollywood, New York, San Francisco, Jurassic Park, Waterworld, Amity Village, Universal Wonderland, and The Wizarding World of Harry Potter. Return to hotel on your own. Overnight stay in Osaka."
  },
  {
    day: "Day 7",
    title: "Osaka Departure",
    content:
      "After breakfast, check out by 10:00. Proceed to Osaka Station on your own and board the SIC transfer to Kansai International Airport (KIX) for your international flight. Return home with sweet memories of Japan."
  }
  ],
  MauritiusOne: [
  {
    day: "Day 1",
    title: "Arrival & Leisure Day",
    content:
      "Begin your Mauritius family package with a relaxing leisure day. Arrive at Sir Seewoosagur Ramgoolam International Airport, where you will be received by our representative. Transfer to your resort and complete check-in formalities. Spend the evening at leisure with your family—visit nearby beaches or explore local markets. Return to the resort for a delicious dinner and a cozy overnight stay."
  },
  {
    day: "Day 2",
    title: "Excursion to Ile Aux Cerfs Island with Water Activities",
    content:
      "After breakfast at the resort, transfer to the stunning Ile Aux Cerfs Island, the most famous island in Mauritius. Soak in the sun and enjoy a range of included water activities such as parasailing, snorkeling, underwater sea walk, and speed boat rides. Spend a fun-filled day with your family amidst crystal-clear waters. Return to the resort for a delectable dinner and a warm overnight stay."
  },
  {
    day: "Day 3",
    title: "Full Day North Island Tour",
    content:
      "Enjoy a healthy breakfast and set out for a full-day North Island excursion. Visit top attractions like Place D’Armes with its French colonial charm, the Champ de Mars Racecourse, and Le Caudan Waterfront—a vibrant commercial hub with casinos, luxury shops, and restaurants where your family can have a delightful time. Head back to the resort for dinner and a restful overnight stay."
  },
  {
    day: "Day 4",
    title: "Full Day South Island Tour",
    content:
      "After breakfast, embark on a full-day South Island tour. Explore the city of Curepipe for retail therapy and fine dining. Visit natural and spiritual sites including Chamarel Waterfall, Grand Bassin (a sacred Hindu lake), and Trou aux Cerfs—an extinct volcanic crater with its famous 7-colored earth. Return to your resort for a final dinner and overnight stay."
  },
  {
    day: "Day 5",
    title: "Departure from Mauritius",
    content:
      "Enjoy your last breakfast in Mauritius. After check-out, transfer to the airport for your flight back home. Depart with wonderful memories of your Mauritius family holiday."
  }
  ],
  MauritiusTwo: [
  {
    day: "Day 1",
    title: "To Mauritius",
    content:
      "After boarding your flight to Mauritius, arrive and meet our local tour operator for a warm welcome. Transfer from the airport to your hotel. After check-in, spend the rest of the day at leisure or enjoy shopping. Relax and overnight stay at the hotel."
  },
  {
    day: "Day 2",
    title: "Ile Aux Cerfs Tour by Speed Boat",
    content:
      "Enjoy breakfast at the hotel, then depart by coach for a full-day excursion to Ile Aux Cerfs, located in an emerald lagoon on the east coast. Take a speed boat from the jetty to the island. Spend the day enjoying the beach or water sports (at your own cost). Return to the hotel in the evening. Dinner and overnight stay at the hotel."
  },
  {
    day: "Day 3",
    title: "Day at Leisure in Mauritius",
    content:
      "Good morning! After a healthy breakfast, explore the local area near your hotel or relax at the beach. Return to the hotel in the evening for dinner. Overnight stay at the hotel."
  },
  {
    day: "Day 4",
    title: "North Island Tour",
    content:
      "After breakfast, head out for a full-day North Island tour. Visit the capital city Port Louis, Place d'Arms with French colonial buildings, Champ de Mars racecourse, Caudan Waterfront, and the Pamplemousses Botanical Garden. Return to the hotel in the evening. Dinner and overnight stay at the hotel."
  },
  {
    day: "Day 5",
    title: "Day at Leisure in Mauritius",
    content:
      "Enjoy breakfast at the hotel. Spend the day at your own leisure—perhaps more shopping, beach time, or relaxing at the resort. Return to the hotel in the evening. Dinner and overnight stay at the hotel."
  },
  {
    day: "Day 6",
    title: "South Island Tour",
    content:
      "Post breakfast, enjoy a full-day South Island tour. Visit Trou aux Cerfs (an extinct volcanic crater), Grand Bassin (a sacred Hindu lake), and Chamarel (with vibrant earth hues and a waterfall). Also visit Curepipe city for shopping and souvenirs. Return for dinner and overnight stay at the hotel."
  },
  {
    day: "Day 7",
    title: "Departure from Mauritius",
    content:
      "After breakfast, check out and transfer to the airport for your onward flight. Depart with beautiful memories of Mauritius."
  }
  ],
  CambodiaOne: [
  {
    day: "Day 1",
    title: "Siem Reap Arrival & Cultural Introduction",
    content:
      "Suas’dei and welcome to the Kingdom of Wonder! Upon arrival in Siem Reap, you will be greeted by our friendly guide and transferred to your hotel in town. In the afternoon, visit either the War Museum, which provides deep insights into Cambodia’s turbulent past, or the Angkor National Museum—a world-class cultural experience spanning 20,000 sq.m and dedicated to the golden era of the Khmer Empire. In the evening, enjoy a delicious dinner accompanied by a mesmerizing Apsara dance performance. Overnight stay in Siem Reap."
  },
  {
    day: "Day 2",
    title: "Angkor Thom, Ta Prohm & Angkor Wat",
    content:
      "Start the day with breakfast at the hotel, then explore the ancient city of Angkor Thom, the final capital of the Khmer Empire. Discover iconic structures like Bayon Temple within its 8-meter-high walls. Continue to the photogenic and jungle-entwined Ta Prohm Temple. In the afternoon, visit the world-renowned Angkor Wat—a grand Hindu temple built in honor of Vishnu by King Suryavarman II. Its intricate bas-reliefs and monumental architecture earned it UNESCO World Heritage status. In the evening, explore the vibrant Pub Street filled with restaurants, bars, and shops. Overnight in Siem Reap. Note: Modest dress is required for temple visits (shoulders and knees must be covered)."
  },
  {
    day: "Day 3",
    title: "Floating Village, Crocodile Farm & Beng Mealea",
    content:
      "After breakfast, take a boat ride to the floating village of Chong Kneas on Tonle Sap Lake. Witness floating homes, schools, and daily life on water, and enjoy warm greetings from the friendly locals. Visit the nearby Crocodile Farm to see a variety of crocodiles and optional feeding or shopping for crocodile-skin products. Later, venture to the hidden gem of Beng Mealea—an untouched, jungle-clad temple around 65 km from Siem Reap. This lesser-known temple offers a unique 'Indiana Jones' experience. Return to Siem Reap for an overnight stay."
  },
  {
    day: "Day 4",
    title: "Old Market Visit & Departure",
    content:
      "Spend your final morning shopping at the Old Market, where you can find a wide range of souvenirs including T-shirts, silverware, silk products, wood and stone carvings, and Buddha statues. Afterward, transfer to the airport for your departure flight, carrying beautiful memories of your journey through Siem Reap."
  }
  ],
  CambodiaTwo : [
  {
    day: "Day 1",
    title: "Arrival in Phnom Penh & Royal Palace Visit",
    content:
      "Welcome to Phnom Penh! Upon arrival, take some rest before beginning your cultural journey. Start with the Khmer-style Royal Palace complex built in 1866, followed by the magnificent Silver Pagoda, which houses golden and jeweled Buddha statues. Visit the Independence Monument and explore the National Museum with over 5,000 ancient artifacts. Stroll through the riverfront park at the confluence of four rivers and climb Phnom Daun Penh Hill for serene views. Enjoy a delightful dinner and overnight stay in Phnom Penh."
  },
  {
    day: "Day 2",
    title: "Phnom Penh History & Sunset Cruise",
    content:
      "Begin the day with a visit to the Tuol Sleng Genocide Museum (S-21), an emotional site from the Khmer Rouge era. Continue to the Choeung Ek Killing Fields for a somber historical experience. Lift your spirits with a vibrant shopping trip at the Russian Market. In the evening, enjoy a scenic sunset cruise on the Mekong and Tonle Sap rivers at the Four Arms junction. Return to Phnom Penh for dinner and an overnight stay."
  },
  {
    day: "Day 3",
    title: "Fly to Siem Reap & Explore Ancient Temples",
    content:
      "Fly to Siem Reap in the morning and check into your hotel. Begin your exploration of the Angkor archaeological complex—a UNESCO World Heritage Site. Visit Prasat Kravan, the serene Srah Srang, and the intricately carved Banteay Srei Temple. Explore the rose-hued Banteay Samre and conclude with a visit to Wat Bo and the local market. End the day with a welcome dinner accompanied by an Apsara dance performance. Overnight stay in Siem Reap."
  },
  {
    day: "Day 4",
    title: "Cycling Adventure through Angkor Temples",
    content:
      "Enjoy a guided cycling tour through local villages and forest trails leading to the temples of Angkor. Explore the majestic Angkor Wat and visit Angkor Thom—the ancient Khmer capital. Marvel at the South Gate, Bayon Temple with its 54 towers, Baphuon Temple, and the sacred Mount Meru representation. Also explore the Terrace of the Leper King, Royal Palace area, and Elephant Terrace. Return to Siem Reap for dinner, and spend the evening exploring the Angkor Night Market or relaxing with a foot massage. Overnight in Siem Reap."
  },
  {
    day: "Day 5",
    title: "Tonle Sap Lake & Departure",
    content:
      "Rise early to witness a stunning sunrise over Angkor. After breakfast, embark on a boat trip to Tonle Sap Lake to experience life in floating villages, floating schools, and restaurants. Later, visit Artisans d’Angkor Silk Farm to witness traditional silk production. Transfer to the airport for your departure flight, carrying wonderful memories of Cambodia’s culture and history."
  }
  ],
  CambodiaThree : [
  {
    day: "Day 1",
    title: "Arrival in Siem Reap & Temple Tour",
    content:
      "Arrive in Siem Reap and take some rest before heading out for a light city tour. Visit the 10th-century East Mebon temple, located on an island in the Oriental Baray reservoir. Continue to Neak Poan and Preah Khan, where King Jayavarman VII once fought against the Chams. Enjoy a welcome dinner with a traditional Apsara dance-drama performance. Overnight stay in Siem Reap."
  },
  {
    day: "Day 2",
    title: "Angkor Sunrise & Ancient Temples",
    content:
      "Wake up early to witness a breathtaking sunrise over the Angkor ruins. Return to your hotel for breakfast, then proceed to explore Angkor's iconic sites including Banteay Srei, Banteay Samre, and Ta Prohm. Visit Prasat Kravan, Srah Srang, Banteay Kdei, Thommanon, and Chau Say Tevoda. Return to Siem Reap for an overnight stay."
  },
  {
    day: "Day 3",
    title: "Cycling Tour of Angkor Temples",
    content:
      "Set out on a cycling adventure through local villages and paved trails to Angkor. Visit Bayon Temple, Baphuon, and other landmarks in Angkor Thom including the Elephant Terrace, Royal Palace area, and Terrace of the Leper King. End your tour at the west gate of Angkor Thom and climb Bakheng Hill for sunset views. Return to Siem Reap for dinner, a relaxing foot massage, and a night out at local pubs. Overnight in Siem Reap."
  },
  {
    day: "Day 4",
    title: "Fly to Phnom Penh & Transfer to Sihanoukville",
    content:
      "Take a morning flight to Phnom Penh and continue by road to Sihanoukville, a charming coastal town on the Gulf of Thailand. Spend the day relaxing on the beach or enjoying activities like snorkeling, scuba diving, and swimming. Dinner and overnight stay in Sihanoukville."
  },
  {
    day: "Day 5",
    title: "Island Boat Trip from Sihanoukville",
    content:
      "Enjoy a boat trip to explore the scenic offshore islands around Sihanoukville. Visit Koh Russei (Bamboo Island) where you can relax on the beach, snorkel in clear waters, or explore the island's lush forests. Return to Sihanoukville for dinner and overnight stay."
  },
  {
    day: "Day 6",
    title: "Return to Phnom Penh & City Tour",
    content:
      "Depart early for Phnom Penh. Visit the beautiful French colonial villas and tree-lined boulevards. Explore the Royal Palace complex and the Silver Pagoda, which houses Buddha statues crafted from gold, diamond, and gemstones. Continue to the Independence Monument and National Museum. Enjoy dinner and overnight stay in Phnom Penh."
  },
  {
    day: "Day 7",
    title: "Tuol Sleng Museum & Departure",
    content:
      "On your final day, visit the Tuol Sleng Genocide Museum (S-21), a somber reminder of Cambodia’s tragic past. After this enlightening visit, transfer to the airport for your departure with lasting memories of Cambodia's culture, history, and natural beauty."
  }
  ],
  SriLankaOne : [
  {
    day: "Day 1",
    title: "Arrival in Jakarta",
    content:
      "Arrive at Soekarno-Hatta International Airport where you will be greeted by our representative. Transfer to your hotel for check-in. Enjoy the rest of the day at leisure."
  },
  {
    day: "Day 2",
    title: "Jakarta Art & Culture Tour",
    content:
      "After breakfast at the hotel, embark on a full-day tour of Jakarta. Visit Taman Mini Indonesia Indah (TMII), a miniature park representing Indonesia’s diverse culture. Explore Museum Indonesia to dive deeper into the country's rich heritage. In the late afternoon, enjoy shopping at ITC Mangga Dua Mall. Dinner will be served at a local restaurant before returning to the hotel. Free time in the evening."
  },
  {
    day: "Day 3",
    title: "Departure from Jakarta",
    content:
      "Enjoy breakfast at the hotel and spend your remaining time at leisure. When it’s time, check out from the hotel and transfer to the airport for your onward flight."
  }
  ],
  SriLankaTwo : [
  {
    day: "Day 1",
    title: "Arrival Denpasar - Hotel",
    content:
      "Welcome to Bali, island of God. After customs and immigration, you will be greeted by our friendly guide outside the baggage hall. Transfer to hotel in Kuta for check-in. In the evening at 6pm, pick up at hotel lobby for dinner at an Indian restaurant."
  },
  {
    day: "Day 2",
    title: "Full Day Water Sport + Sunset Tanah Lot Tour",
    content:
      "After breakfast, be ready at hotel lobby by 9:00am for water sports. Enjoy a one-time visit to Turtle Island by Glass Bottom Boat and one-time Banana Boat ride (other activities at your own expense). Lunch provided at Indian restaurant. Continue to Tanah Lot Sunset Tour, visiting the iconic ocean-front Tanah Lot Temple. Dinner at Indian restaurant, then return to hotel."
  },
  {
    day: "Day 3",
    title: "Departure Denpasar - Airport",
    content:
      "After breakfast at hotel, enjoy free time at your leisure until transfer to the airport for your departure flight."
  }
  ],
  SriLankaThree : [
  {
    day: "Day 01",
    title: "Arrive Bali",
    content:
      "Arrive at Bali International Airport and meet our representatives for transfer to the hotel. Take a break for lunch. Proceed to Uluwatu Temple at the southern tip of the peninsula to explore its historic value and overlook the Indian Ocean. Experience the local tribal culture. Dinner at Jimbaram Beach with grilled seafood and fun. Return to hotel for overnight stay."
  },
  {
    day: "Day 02",
    title: "Barong and Volcano Tour",
    content:
      "After breakfast at the hotel, take a full day tour starting with Batubulan to watch the traditional “Barong & Keris Dance”. Visit MAS, the silver and gold handicrafts center, and UBUD, home of top painters. Continue to Kintamani with Mt. Batur views and fresh mountain air. In the evening, visit Tampaksiring, a 1000-year-old site for blessings. Return to hotel for dinner and overnight stay."
  },
  {
    day: "Day 03",
    title: "Bedugul and Tanah Lot Tour",
    content:
      "After breakfast, visit Mengwi and the royal Taman Ayun Temple. Then proceed to Bedugul, a cool mountain resort with the beautiful Lake Beratan and Ulun Danu Temple. Enjoy lunch and visit Alas Kedaton Monkey Forest inhabited by protected monkeys. End the day at Tanah Lot, an offshore temple on a small promontory, perfect for photos and relaxation. Return to hotel for dinner and overnight stay."
  },
  {
    day: "Day 04",
    title: "Bali Departure",
    content:
      "Enjoy morning breakfast and transfer to the airport for your departure."
  }
  ],
  IndonesiaOne : [
  {
    day: "Day 1",
    title: "Arrival in Jakarta",
    content:
      "Arrive at Soekarno-Hatta International Airport where you will be greeted by our representative. Transfer to your hotel for check-in. Enjoy the rest of the day at leisure."
  },
  {
    day: "Day 2",
    title: "Jakarta Art & Culture Tour",
    content:
      "After breakfast at the hotel, embark on a full-day tour of Jakarta. Visit Taman Mini Indonesia Indah (TMII), a miniature park representing Indonesia’s diverse culture. Explore Museum Indonesia to dive deeper into the country's rich heritage. In the late afternoon, enjoy shopping at ITC Mangga Dua Mall. Dinner will be served at a local restaurant before returning to the hotel. Free time in the evening."
  },
  {
    day: "Day 3",
    title: "Departure from Jakarta",
    content:
      "Enjoy breakfast at the hotel and spend your remaining time at leisure. When it’s time, check out from the hotel and transfer to the airport for your onward flight."
  }
  ],
  IndonesiaTwo : [
  {
    day: "Day 1",
    title: "Arrival Denpasar - Hotel",
    content:
      "Welcome to Bali, island of God. After customs and immigration, you will be greeted by our friendly guide outside the baggage hall. Transfer to hotel in Kuta for check-in. In the evening at 6pm, pick up at hotel lobby for dinner at an Indian restaurant."
  },
  {
    day: "Day 2",
    title: "Full Day Water Sport + Sunset Tanah Lot Tour",
    content:
      "After breakfast, be ready at hotel lobby by 9:00am for water sports. Enjoy a one-time visit to Turtle Island by Glass Bottom Boat and one-time Banana Boat ride (other activities at your own expense). Lunch provided at Indian restaurant. Continue to Tanah Lot Sunset Tour, visiting the iconic ocean-front Tanah Lot Temple. Dinner at Indian restaurant, then return to hotel."
  },
  {
    day: "Day 3",
    title: "Departure Denpasar - Airport",
    content:
      "After breakfast at hotel, enjoy free time at your leisure until transfer to the airport for your departure flight."
  }
  ],
  IndonesiaThree : [
  {
    day: "Day 01",
    title: "Arrive Bali",
    content:
      "Arrive at Bali International Airport and meet our representatives for transfer to the hotel. Take a break for lunch. Proceed to Uluwatu Temple at the southern tip of the peninsula to explore its historic value and overlook the Indian Ocean. Experience the local tribal culture. Dinner at Jimbaram Beach with grilled seafood and fun. Return to hotel for overnight stay."
  },
  {
    day: "Day 02",
    title: "Barong and Volcano Tour",
    content:
      "After breakfast at the hotel, take a full day tour starting with Batubulan to watch the traditional “Barong & Keris Dance”. Visit MAS, the silver and gold handicrafts center, and UBUD, home of top painters. Continue to Kintamani with Mt. Batur views and fresh mountain air. In the evening, visit Tampaksiring, a 1000-year-old site for blessings. Return to hotel for dinner and overnight stay."
  },
  {
    day: "Day 03",
    title: "Bedugul and Tanah Lot Tour",
    content:
      "After breakfast, visit Mengwi and the royal Taman Ayun Temple. Then proceed to Bedugul, a cool mountain resort with the beautiful Lake Beratan and Ulun Danu Temple. Enjoy lunch and visit Alas Kedaton Monkey Forest inhabited by protected monkeys. End the day at Tanah Lot, an offshore temple on a small promontory, perfect for photos and relaxation. Return to hotel for dinner and overnight stay."
  },
  {
    day: "Day 04",
    title: "Bali Departure",
    content:
      "Enjoy morning breakfast and transfer to the airport for your departure."
  }
  ],
  LaosOne : [
  {
    day: "Day 1",
    title: "Luang Prabang – Arrival",
    content: `Luang Prabang is a sleepy town known for its rich Lao culture and natural beauty. Upon arrival, you'll be welcomed by our local guide and transferred to your hotel for check-in. Spend the day at leisure. Dinner at an Indian restaurant. Overnight stay in Luang Prabang.`
  },
  {
    day: "Day 2",
    title: "Luang Prabang – City Tour & Kuangsi Waterfalls (B/L/D)",
    content: `After breakfast, visit the National Museum (former Royal Palace) showcasing Laos' royal past, including the sacred Buddha image Prabang. Visit Wat Mai temple famous for golden bas-reliefs. Explore the Traditional Arts and Ethnology Centre highlighting Laos’ ethnic groups.

Lunch at an Indian restaurant.

In the afternoon, visit the Kuangsi Waterfalls with turquoise pools and limestone cliffs; optional swimming available. Visit the Sun Bear Reserve nearby. On return, stop at Ban Tha Pane (Khmu) and Ban Na Ouane (Hmong) villages to learn about local lifestyles.

Climb 328 steps up Phou Si Hill for panoramic city and temple views at sunset. Explore the vibrant Luang Prabang Night Market with local handicrafts and street food.

Dinner at an Indian restaurant by the Mekong River. Overnight in Luang Prabang.`
  },
  {
    day: "Day 3",
    title: "Luang Prabang – Pak Ou Caves (B/L/D)",
    content: `Visit Wat Xieng Thong, a 16th-century temple near the Mekong River, known for ornate carvings and mosaics.

Board a local boat at Luang Prabang Pier to cruise upstream on the Mekong River to the sacred Buddha caves of Pak Ou, housing hundreds of Buddha statues.

Cross the river for lunch at a local restaurant, then cruise back downstream. Visit riverside villages Ban Xanghai (famous for Laolao rice wine) and Ban Xang Khong (known for handmade paper and weaving).

In the evening, participate in the traditional Baci Ceremony at a local family’s home, a spiritual blessing ritual involving tying white threads to wrists.

Enjoy dinner with your host family featuring traditional Lao cuisine.

Overnight in Luang Prabang.`
  },
  {
    day: "Day 4",
    title: "Luang Prabang – Departure",
    content: `Morning at leisure until transfer to the airport for your onward flight.

End of trip.`
  }
  ],
  LaosTwo : [
  {
    day: "Day 1",
    title: "Arrival – Vientiane",
    content: `On arrival in the Laos capital of Vientiane, you will be met and transferred to your centrally located hotel. Vientiane is a charming capital with Lao, Thai, Chinese, Vietnamese, French, and American influences. After a short rest, visit major sights including Wat Sisaket (oldest temple with thousands of miniature Buddha statues), the former royal temple Wat Prakeo (housed the Emerald Buddha), and the That Luang Stupa, Laos’ national icon. En route, stop at Patuxay Monument, Vientiane’s Arc de Triomphe. End the day at the Mekong riverside to admire the sunset. Overnight in Vientiane.`
  },
  {
    day: "Day 2",
    title: "Vientiane – Vang Vieng (Road)",
    content: `Early departure northbound, passing spectacular countryside and mountains. Stop at the colorful Thalat market where hill tribes trade goods. Visit Vang Xang archaeological site dating back to the 11th century. Arrive in Vang Vieng, located on the Nam Song River bend, known for stunning limestone scenery. Check into hotel and enjoy leisure time. Overnight in Vang Vieng. (B)`
  },
  {
    day: "Day 3",
    title: "Vang Vieng – Luang Prabang (Road)",
    content: `Explore Tham Jang caves (historic hideout from Chinese invaders) 2km outside Vang Vieng. Visit Ban Huai Ngai village to experience local lifestyles. Journey through stunning mountain scenery to Luang Prabang, UNESCO’s “best preserved traditional city in Southeast Asia.” Enjoy the serene town with gleaming temples and colonial architecture. Overnight in Luang Prabang. (B)`
  },
  {
    day: "Day 4",
    title: "Luang Prabang – City Tour",
    content: `Visit the former Royal Palace, now the National Museum (closed Tuesdays), showcasing Lao cultural artifacts. Explore Wat Visoun (stupa), Wat Aham shrine, Wat Sene (oldest temple), and Wat Mai with its five-tiered roofs. Climb 329 steps to Phousi Hill for sunset views over the city and Mekong River. Overnight in Luang Prabang.`
  },
  {
    day: "Day 5",
    title: "Luang Prabang – Pak Ou Caves",
    content: `Visit Wat Xieng Thong temple at the Mekong and Nam Khan rivers junction, decorated with gilded stuccoes and the “tree of life” mosaic. Cruise upstream on the Mekong River to Pak Ou Caves, home to thousands of gold lacquered Buddha statues. Stop at Ban Xang Hai village, famous for local rice wine. Return via Ban Phanom weaving village, a great spot for shopping and bargaining. Overnight in Luang Prabang.`
  },
  {
    day: "Day 6",
    title: "Luang Prabang – Vientiane – Departure",
    content: `Free time to explore Luang Prabang's Central Market before transfer to the airport for a short flight back to Vientiane. Connect to your onward flight and depart Laos.`
  }
  ],
  LaosThree : [
  {
    day: "Day 1",
    title: "Arrival – Luang Prabang – Half Day City Tour",
    content: `On arrival at the airport, you will be met and transferred to your hotel. Time permitting, your half day city tour begins with a visit to the Royal Palace Museum, which hosts a range of interesting artifacts. Next, visit the magnificent Wat Xiengthong with its sweeping roofs, representing classical Laotian architecture. Also visit the impressive stupa of Wat Visoun and the shrines of Wat Aham and Wat Mai. Overnight in Luang Prabang.`
  },
  {
    day: "Day 2",
    title: "Luang Prabang – Big Brother Mouse – Ban Khia Luang – Pak Ou Caves",
    content: `Start the day at the Big Brother Mouse shop to select books for the village visit. Drive north on Route 13, then take an unpaved road to Ban Khia Luang village. Visit the school, play with kids, and watch them enjoy new books. Explore the village including weaving and the local temple. Lunch in the village with a choice of western picnic or traditional Lao food like sticky rice, laap, and fresh vegetables. After lunch, drive through scenic mountains and paddy fields to Ban Khoklin. Board a private boat on the Nam Ou River for 30 minutes to Pak Ou Caves, two linked caves with thousands of gold lacquered Buddha statues left by pilgrims. Return down the Mekong River to Luang Prabang by late afternoon. Overnight in Luang Prabang.`
  },
  {
    day: "Day 3",
    title: "Luang Prabang – Khuang Si Waterfall and Ban Chan",
    content: `Cross the Mekong River by boat to Ban Chan, a pottery village. Visit the morning Phousi Market with diverse offerings like dried buffalo skin, local tea, saltpeter, chickens, vegetables, and hill-tribe weavings. Visit local ethnic minority villages: Ban Ouay (Hmong), Ban Ou (Laoloum), and Ban Thapene (Khmu). Visit Khuang Si Waterfall for a refreshing swim or forest trail walk. Return to Luang Prabang by late afternoon. Overnight in Luang Prabang.`
  },
  {
    day: "Day 4",
    title: "Luang Prabang – Vientiane – Half Day City Tour (Flight)",
    content: `Transfer to the airport for flight to Vientiane. Upon arrival, transfer to your hotel. Half day city tour of Vientiane includes visits to Wat Sisaket (oldest temple with thousands of miniature Buddha statues), former royal temple Wat Prakeo (housed the Emerald Buddha), the national icon That Luang Stupa, and photo stops at the imposing Patuxay Monument, Vientiane’s Arc de Triomphe. Overnight in Vientiane.`
  },
  {
    day: "Day 5",
    title: "Vientiane – Pakse – Tad Lo",
    content: `Early transfer to the airport for flight to Pakse. On arrival, travel by road to the Bolaven Plateau, known for its cooler climate and waterfalls. Visit Tad Fan waterfall, a spectacular twin waterfall plunging into a deep gorge surrounded by lush vegetation. Observe cultivation of coffee, tea, cardamom, bananas, and more en route. In the afternoon, arrive at Tad Lo, home to another scenic waterfall and ethnic minority villages. Visit the villages of Alak, Nge, and Katu. Overnight in Tad Lo.`
  },
  {
    day: "Day 6",
    title: "Tad Lo – Wat Phou – 4000 Islands",
    content: `After breakfast, depart Tad Lo with a short detour to Pha Suam waterfall and visit ethnic Lao Teung minority villages. Continue by road via Pakse town, cross the Mekong by ferry, and visit the pre-Angkorian ruins of Wat Phu, one of Southeast Asia’s most dramatic temples. After lunch, journey by long tail boat to the 4000 Islands area for relaxation. Overnight in 4000 Islands.`
  },
  {
    day: "Day 7",
    title: "4000 Islands and Surroundings",
    content: `After breakfast, travel south by road and boat to Done Khone. Explore Ban Khone’s French colonial heritage and glimpse the first Lao railway with its locomotive. Continue exploring the 4000 Islands area by boat to Liphi waterfall (Samphamith), a natural border between Laos and Cambodia. Return to Ban Nakasang and visit Khone Phapheng waterfall, the largest in Southeast Asia, known as the ‘Niagara of the East’. Overnight in 4000 Islands.`
  },
  {
    day: "Day 8",
    title: "4000 Islands – Pakse – Departure",
    content: `After breakfast, transfer back to Pakse for your flight to Siem Reap, Cambodia, or exit Laos overland via Chongmek International checkpoint to Ubon Ratchathani, Thailand.`
  }
  ],
  VietnamOne : [
  {
    day: "Day 1",
    title: "Arrive in Hanoi – City Tour",
    content: `Xin chao! Welcome to Hanoi, Vietnam. You are greeted by your guide and driver at Noi Bai International Airport for your transfer to the hotel (check-in after 14:00). Hanoi is one of Asia’s most enchanting cities, full of culture, history, and the engaging contradictions of a rapidly developing yet deeply traditional society. After lunch at an Indian restaurant, visit Hoan Kiem Lake and Ngoc Son Temple. Then enjoy shopping at the Old Quarter and Dong Xuan Market. Dinner at an Indian restaurant. Overnight in Hanoi.`
  },
  {
    day: "Day 2",
    title: "Hanoi – Halong Bay Overnight Cruise",
    content: `This morning, transfer from your hotel in Hanoi to Halong City (about 4 hours' drive, with a refreshment break en route). On arrival, the junk crew welcomes you on board the cruise to explore Halong Bay. Lunch is served on board. Spend the rest of the day cruising among the myriad of tiny islands and exploring grottoes formed by wind and waves. Enjoy a cooking demonstration and dinner on board. Overnight on the cruise.
    
Note: Cruise itinerary is subject to change due to weather. Meals served are local Vietnamese food.`
  },
  {
    day: "Day 3",
    title: "Halong Bay – Hanoi",
    content: `Start your day with a Tai Chi demonstration on the sundeck; tea and coffee are available. A light breakfast is served in the restaurant. Continue exploring Halong Bay. Return to the main boat for check-out (place your baggage in the corridor and settle your bill). Brunch will be served. Disembark at the harbor around noon and transfer back to Hanoi. Upon arrival, visit Tran Quoc Pagoda in West Lake and the Temple of Literature – the first university of Vietnam. End the day with a Water Puppet Show. Dinner at an Indian restaurant. Overnight in Hanoi.`
  },
  {
    day: "Day 4",
    title: "Hanoi City – Fly to Siem Reap",
    content: `Enjoy breakfast at the hotel. Visit the Ho Chi Minh complex including the Presidential Palace, House on Stilts, and One Pillar Pagoda. Lunch at an Indian restaurant. After lunch, transfer to the airport for your flight to Siem Reap. Upon arrival, transfer to your hotel for check-in. Enjoy dinner with a traditional Apsara dance show. Overnight in Siem Reap.`
  },
  {
    day: "Day 5",
    title: "Angkor Thom, Ta Prohm, Angkor Wat",
    content: `Wake up early and have breakfast at the hotel. Start your exploration with Angkor Thom – the last capital of the Great Khmer Empire, surrounded by 8m-high walls. Continue to Ta Prohm Temple, famous for its atmospheric jungle surroundings and photogenic trees growing among the ruins. In the afternoon, visit the world-famous Angkor Wat – a masterpiece of Khmer architecture and the largest religious monument in the world, built for the Hindu god Vishnu. In the evening, explore Pub Street, known for its lively bars, discos, and restaurants. Overnight in Siem Reap.

Note: Only long pants and shirts covering shoulders are allowed inside the Angkor Temple Complex.`
  },
  {
    day: "Day 6",
    title: "Siem Reap – Departure",
    content: `Spend the morning shopping at the Old Market – a great place to find souvenirs, silk, T-shirts, silverware, wooden carvings, and Buddha statues. Later, transfer to the airport for your departure flight. End of service.`
  }
  ],
  VietnamTwo : [
  {
    day: "Day 1",
    title: "Hanoi: Arrival and City Tour",
    content: `A trip full of adventure, fun, and intrigue begins in Hanoi. Upon arrival at Hanoi International Airport, you will be welcomed by a tour representative and transferred to your hotel. After check-in, enjoy the day at leisure—relax at the hotel or explore nearby attractions. If visiting on a weekend, don't miss the vibrant night market or savor street food specialties. Overnight in Hanoi.`
  },
  {
    day: "Day 2",
    title: "Hanoi: Halong Bay Cruise Experience",
    content: `Post breakfast, embark on a scenic drive to Halong Bay. En route, stop at the Humanity Centre to try some local treats. Upon arrival, board a cruise ship and enjoy lunch onboard while cruising past majestic caves. Visit the renowned Surprise Cave, then go kayaking around the fishing village. End the day with a Sunset Party, swimming, and a delicious barbecue dinner onboard. Engage in fun activities like karaoke, squid fishing, and stargazing. Overnight on the cruise.`
  },
  {
    day: "Day 3",
    title: "Ho Chi Minh City: Cruise Activities and Flight",
    content: `Enjoy a fresh fruit breakfast onboard and visit a pearl farm. Continue to smaller islets, followed by a cooking class on Vietnamese cuisine. After lunch, disembark and return to Hanoi. From there, catch a flight to Ho Chi Minh City. Upon arrival, transfer to your hotel and rest for the night.`
  },
  {
    day: "Day 4",
    title: "Ho Chi Minh City: City Tour and Cu Chi Tunnels",
    content: `After breakfast, visit Notre Dame Cathedral, Central Post Office, Reunification Palace, and the War Remnants Museum. Then head 60 km out to explore the fascinating Cu Chi Tunnels—an underground network used during wartime. Experience guerrilla life with tea and cassava tasting. Return to Ho Chi Minh City for an overnight stay.`
  },
  {
    day: "Day 5",
    title: "Ho Chi Minh City: My Tho and Ben Tre Excursion",
    content: `Enjoy breakfast and set off for My Tho via scenic rice fields. Visit Vinh Trang Pagoda, then cruise to Tortoise Islet for lunch amidst a fruit orchard. Continue to An Khanh by boat, relax along natural canals, and enjoy local folk music, honey tea, and seasonal fruits. Visit a coconut candy family business for insights into rural life. Return to Ho Chi Minh City for the night.`
  },
  {
    day: "Day 6",
    title: "Siem Reap: Arrival and Angkor Wat Complex Tour",
    content: `Fly to Siem Reap, Cambodia. Upon arrival, begin exploring the Angkor Wat Complex: South Gate of Angkor Thom, Bayon Temple, Terrace of the Elephants, Terrace of the Leper King, Baphuon, Royal Palace, Phimeanakas, and Sur Prat Temple. Visit the iconic Angkor Wat and end the day at Phnom Bakheng Hill to witness a breathtaking sunset. Overnight in Siem Reap.`
  },
  {
    day: "Day 7",
    title: "Siem Reap: Ta Prohm and Banteay Srei Exploration",
    content: `After breakfast, visit the intricately carved Banteay Srei Temple, known for its pink sandstone and nickname “Citadel of Women.” Then explore Ta Prohm, a picturesque ruin entangled with tree roots and famous as the filming location for *Tomb Raider*. Return to the hotel in Siem Reap for an overnight stay.`
  },
  {
    day: "Day 8",
    title: "Siem Reap: Departure",
    content: `Enjoy your final breakfast in Cambodia before checking out. Depending on your flight time, you may explore local markets or simply relax until your airport transfer. Bid farewell to an unforgettable journey through Vietnam and Cambodia.`
  }
  ]
};

export default itineraries;
